import React, { useEffect } from 'react';
import {
  useParams,
} from 'react-router-dom';

import { env } from '~/commons/config';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import Header from '../../layout/Header.jsx';
import PageHttp from '~/commons/components/PageHttp.jsx';
import FormStudent from '../../forms/FormStudent.jsx';

const PageSchoolStudent = () => {
  const { _id, studentId } = useParams();
  const [schoolRes, schoolReq] = useHttpStatus();
  const [studentRes, studentReq] = useHttpStatus();

  useEffect(() => {
    schoolReq({ url: `api/core/schools/${_id}` });

    if (studentId !== 'new') {
      studentReq({ url: `api/core/users/students/${studentId}` });
    }
  }, [_id, studentId]);

  const res = [schoolRes];

  if (studentId !== 'new') {
    res.push(studentRes);
  }

  return (
    <PageHttp res={res}>
      {([school, student]) => {
        const breadcrumb = [
          { to: '../../../', children: 'Schools' },
          { to: '../../', children: school.title.en || school.title.zhhk },
        ];

        return studentId === 'new' ? (
          <>
            <Header breadcrumb={breadcrumb}>New Student</Header>
            <FormStudent school={school} />
          </>
        ) : (
          <>
            <Header breadcrumb={breadcrumb}>Edit Student</Header>
            <FormStudent
              school={school}
              student={student}
            />
          </>
        );
      }}
    </PageHttp>
  );
};

export default PageSchoolStudent;
